

import { mapStores } from "pinia";
import { defineComponent } from "vue";
import basePage from "~/core/base-page";
import { useAuthStore } from "~/store/auth.store";

import { NForm, NFormItem, NInput, FormRules, NAlert,NSpin } from 'naive-ui';

export default defineComponent({

    extends: basePage,

    components: {
        NInput,
        NForm,
        NFormItem,
        NAlert,
        NSpin,
    },

    data() {
        return {
            result: {
                username: '',
                password: ''
            },
            messages: {
                required: this.$t('login.form.required'),
            },
            rules: {
                username: { required: true, trigger: ['submit']},
                password: { required: true, trigger: ['submit']},
            } as FormRules,
            failed: false,
            valid: false,
            showPassword: false,
            loading: false,
        };
    },

    computed: {
        ...mapStores(useAuthStore),
        logo() {
            return require('./../../img/avolta-connect-logo.png').default
        },
        userImg() {
            return require('../../img/profile-pic.png').default
        }
    },
    mounted() {
        if (this.authStore.isLogged) {
            this.$router.push('/dashboard');
        }
    },

    methods: {
        async onSubmit(e: Event) {
            e.preventDefault();
            await this.authStore.logout();
            this.failed = false;
            this.loading = true;

            await this.authStore.login(this.result?.username, this.result?.password)
                .then(() => this.$router.push({ name: 'dashboard',  params: { group: 'default'}}))
                .catch((error) => {
                    this.failed = true;
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        togglePasswordVisibility(): void {
            this.showPassword = !this.showPassword;
        }
    },

    
    watch: {
        result: {
            handler() {
                //@ts-ignore
                this.$refs?.form?.validate((errors) => {
                    this.valid = !errors;
                })
                .catch((err: Error) => {
                    if (err) {
                            this.valid = false;
                    }
                });
            },
            deep: true,
        }
    }

});

